var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullpage bg_fff"},[_c('div',{staticClass:"Section0",staticStyle:{"layout-grid":"15.6000pt"}},[_c('pj-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }